// Google Analytics için tip tanımlaması
declare global {
  interface Window {
    gtag: (command: string, action: string, params?: any) => void;
    dataLayer: any[];
  }
}

// Google Analytics için olay izleme yardımcı fonksiyonları

/**
 * Google Analytics'e olay gönderir
 * @param eventName - Olayın adı (örn: 'button_click', 'form_submit')
 * @param params - Olayla ilgili ek parametreler
 */
export const trackEvent = (eventName: string, params: Record<string, any> = {}) => {
  // gtag fonksiyonu tanımlanmış mı kontrol et
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, params);
  } else {
    console.warn('Google Analytics yüklenmemiş, olay izlenemedi:', eventName);
  }
};

/**
 * Düğme tıklama olayını izler
 * @param buttonName - Düğmenin adı/tanımı
 * @param buttonLocation - Düğmenin sayfadaki konumu (örn: 'header', 'sidebar')
 */
export const trackButtonClick = (buttonName: string, buttonLocation: string = 'unknown') => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: buttonLocation
  });
};

/**
 * Sayfa görüntüleme olayını izler (SPA için)
 * @param pageName - Sayfa adı
 * @param pageTitle - Sayfa başlığı
 */
export const trackPageView = (pageName: string, pageTitle: string) => {
  trackEvent('page_view', {
    page_name: pageName,
    page_title: pageTitle
  });
};

/**
 * Form gönderim olayını izler
 * @param formName - Form adı
 * @param formSuccess - Form başarıyla gönderildi mi
 */
export const trackFormSubmit = (formName: string, formSuccess: boolean = true) => {
  trackEvent('form_submit', {
    form_name: formName,
    form_success: formSuccess
  });
}; 